export default function LeftArrow() {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M16 12L7 12M7 12L10.913 16M7 12L10.913 8" stroke="#212121" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}